<template>
  <category-page
    :resource-params="resourceParams"
    :available-filters="availableFilters"
    :parent="parent"
  />
</template>

<script>
/* List resources by year level
 *
 * @parent:
 * @requests: /public/v1/category
 * @events:
 * @props:
 * @components: CategoryPage
 * @methods:
 */

import CategoryPage from '~/components/category/CategoryPage.vue';

const root = 'year-level';

export default {
  name: 'YearLevel',
  components: {
    CategoryPage,
  },
  async asyncData({ app, store, route, params, error }) {
    const data = {};

    // For the resource list query
    data.resourceParams = {
      category: params.slug,
      perPage: 32,
      root: root + '-' + app.i18n.locale,
    };

    try {
      // Load the category title, description and list of sub-categories
      const category = await store.dispatch('loadCategory', {
        country: app.i18n.locale,
        category: params.slug,
        root: root + '-' + app.i18n.locale,
        link: route.path,
      });

      // For meta fields
      data.title = category.name + ' Teaching Resources';
      data.description = app.$truncateString(category.description, 160, true);
      data.category = category;
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'Teaching Resources by year',
      description: 'Browse resources by year level',
      parent:
        this.$i18n.locale === 'us'
          ? { link: '/' + this.$i18n.locale + '/grade-levels/', name: 'Grade Levels' }
          : { link: '/' + this.$i18n.locale + '/year-levels/', name: 'Year Levels' },
      resourceParams: {},
      category: {},
      availableFilters: [
        'types',
        'learning_areas',
        'resource_types',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'og-title', property: 'og:title', content: this.title },
      ],
      link: this.$hrefLangsResource(
        this.category.linked,
        this.category.link,
        this.$i18n.locale,
        this.$route
      ),
    };
  },
};
</script>
